import React, { useContext } from "react";
import styled from "styled-components";
import { APIContext } from "../../contexts/APIContext";
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green
      ? "#0adb93"
      : props.red
      ? "#db0a41"
      : props.layout === "middle"
      ? "#202731"
      : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 50px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
function FixturesResults({ component, game, previewGraphic }) {
  const { getFixtures } = useContext(APIContext);
  return (
    <GraphicButton
      onClick={async () => {
        let fixtures = await getFixtures({
          date: game.date,
          competition: game?.competition?._id,
        });
        if (!fixtures) return;

        fixtures = fixtures?.filter(
          (f) => f?.competition?._id === game?.competition?._id
        );
        fixtures = fixtures.map((fix) => {
          return {
            ...fix,
            home_scorers: new Array(
              (fix.opta_scores?.total?.home ?? 0) -
                (fix.opta_scores?.pen?.home ?? 0)
            ),
            away_scorers: new Array(
              (fix.opta_scores?.total?.away ?? 0) -
                (fix.opta_scores?.pen?.away ?? 0)
            ),
          };
        });
        previewGraphic("Fixtures", {
          fixtures,
          game,
          ...component.data.options,
        });
      }}
    >
      {component?.data?.label}
    </GraphicButton>
  );
}

export default FixturesResults;
